import MiniCartView from './mini-cart-view'

export default MiniCartView
